<template>
  <div v-loading="nalaganjeUporabnihStrani">
    <div>
      <ul>
        <li>
          <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png">
          <span class="open-sans-24pt">
            Novice
          </span>
        </li>
      </ul>
      <div class="postavitev-paketi-televizija">
        <div class="okvir-novic" v-for="novica in noviceKoristneInformacije">
          <div class="postavitev-slike">
            <a :href="novica.article.url">
              <span v-if="novica.article.image_small !== ''">
                <img class="oblika-slike" :src="novica.article.image_large">
              </span>
              <span v-else>
                <img class="oblika-slike" src="/static/img/UporabniskiKoticek/UporabneStrani/slika_clanki_t2.jpg">
              </span>
            </a>
          </div>
          <div class="odmik-title">
            <a :href="novica.article.url">
              <p class="povezava-oblika">
                {{ novica.article.title }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="zgornji-odmik">
      <ul>
        <li>
          <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-material-live-tv.png">
          <span class="open-sans-24pt">
            Televizija
          </span>
        </li>
      </ul>
      <div class="postavitev-paketi-televizija">
        <div class="okvir-novic" v-for="novica in noviceTelevizija">
          <div class="postavitev-slike">
            <a :href="novica.article.url">
              <span v-if="novica.article.image_small !== ''">
                <img class="oblika-slike" :src="novica.article.image_large">
              </span>
              <span v-else>
                <img class="oblika-slike" src="/static/img/UporabniskiKoticek/UporabneStrani/slika_clanki_t2.jpg">
              </span>
            </a>
          </div>
          <div style="clear: both"/>
          <div class="odmik-title">
            <a :href="novica.article.url">
              <p class="povezava-oblika">
                {{ novica.article.title }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="zgornji-odmik">
      <ul>
        <li>
          <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-phone-alt.png">
          <span class="open-sans-24pt">
            Telefonija
          </span>
        </li>
      </ul>
      <div class="postavitev-paketi-televizija">
        <div class="okvir-novic" v-for="novica in noviceTelefonija">
          <div class="postavitev-slike">
            <a :href="novica.article.url">
              <span v-if="novica.article.image_small !== ''">
                <img class="oblika-slike" :src="novica.article.image_large">
              </span>
              <span v-else>
                <img class="oblika-slike" src="/static/img/UporabniskiKoticek/UporabneStrani/slika_clanki_t2.jpg">
              </span>
            </a>
          </div>
          <div class="odmik-title">
            <a :href="novica.article.url">
              <p class="povezava-oblika">
                {{ novica.article.title }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="zgornji-odmik">
      <ul>
        <li>
          <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-wifi.png">
          <span class="open-sans-24pt">
            Internet
          </span>
        </li>
      </ul>
      <div class="postavitev-paketi-televizija">
        <div class="okvir-novic" v-for="novica in noviceInternet">
          <div class="postavitev-slike">
            <a :href="novica.article.url">
              <span v-if="novica.article.image_small !== ''">
                <img class="oblika-slike" :src="novica.article.image_large">
              </span>
              <span v-else>
                <img class="oblika-slike" src="/static/img/UporabniskiKoticek/UporabneStrani/slika_clanki_t2.jpg">
              </span>
            </a>
          </div>
          <div class="odmik-title">
            <a :href="novica.article.url">
              <p class="povezava-oblika">
                {{ novica.article.title }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PridobiNovice} from 'src/assets/js/globalne_funkcije/PridobivanjeNovic/PridobiNovice'

export default {
  name: 'UporabneStraniPovezave',
  mixins: [PridobiNovice],
  data () {
    return {
      novicePogostaVprasanja: [],
      noviceTelevizija: [],
      noviceTelefonija: [],
      noviceInternet: [],
      noviceKoristneInformacije: [],
      nalaganjeUporabnihStrani: true
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetSeznamNovic()
  },
  methods: {
    SeznamNovic (novicePogostaVprasanja) {
      for (let i = 0; i < novicePogostaVprasanja.length; i++) {
        if (novicePogostaVprasanja[i].article.category === 'Televizija') {
          this.noviceTelevizija.push(novicePogostaVprasanja[i])
        } else if (novicePogostaVprasanja[i].article.category === 'Telefonija') {
          this.noviceTelefonija.push(novicePogostaVprasanja[i])
        } else if (novicePogostaVprasanja[i].article.category === 'Internet') {
          this.noviceInternet.push(novicePogostaVprasanja[i])
        } else if (novicePogostaVprasanja[i].article.category === 'Koristne informacije') {
          this.noviceKoristneInformacije.push(novicePogostaVprasanja[i])
        }
      }
      this.nalaganjeUporabnihStrani = false
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/UporabniskiKoticek/UporabneStrani/UporabneStraniPovezave.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/UporabneStrani/UporabneStraniPovezave.vue